import m from 'mithril'

import PortalArrow from './PortalArrow.js'

export default {
  view: vnode => {
    const text = vnode.attrs.hotspot.text
    const heading = vnode.attrs.hotspot.heading
    const portalHeight = vnode.attrs.hotspot.portalHeight || 0

    return (
      <article className={`hotspot-inner hotspot-portal mod-${vnode.attrs.hotspot.id}`}>
        {heading && <h1 className="hotspot-portal-heading u-hotspot-fade">{heading}</h1>}
        <PortalArrow portalHeight={portalHeight} />

        {text && <p className="hotspot-portal-text u-hotspot-fade">{text}</p>}
      </article>
    )
  }
}
